import React from "react";
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';

function Header() {
  return (
    <header>
      <h1>
        <SpeakerNotesIcon /> Notes
      </h1>
    </header>
  );
}

export default Header;
